const semanticClassNames = {
  leftArrow: 'date-picker-head__left-arrow',
  rightArrow: 'date-picker-head__right-arrow',
} as const;

export default semanticClassNames;
